/* global axios */
import ApiClient from './ApiClient';

class HorarioUsoAPI extends ApiClient {
  constructor() {
    super('horario_uso', { accountScoped: true });
  }

  // GET /horario_uso
  // -> { data_hoje, config, config_dia, horario_padrao, defaults, grupos }
  fetch() {
    return axios.get(this.url);
  }

  // POST /horario_uso
  // payload: { data, liberados, horarios_papel, horarios_usuario, horario_padrao }
  save(payload) {
    return axios.post(this.url, payload);
  }
}

export default new HorarioUsoAPI();
